import Vue from 'vue'
import Router from 'vue-router'

import Search from '@/components/Search.vue'
import Shop from '@/components/Shop.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	relative: true,
	base:'/shop',
	routes: [
		{
			path: '/',
			name: 'Search',
			component: Search
		},
		{
			path: '/:id',
			name: 'Shop',
			component: Shop,
			props: route => ({id: Number(route.params.id)})
		},
		{
			path: '/*',
			name: 'notfound',
			component: Search
		},
	],
	scrollBehavior () {
		return { x: 0, y: 0 }
	}
});
